// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../../../revvComponents";

// Internal Imports
import { IMAGE_URLS } from "../../../../constants";

const { BULK_ESIGN: AcceptanceGraphic } = IMAGE_URLS;

class SuccessCreationPopup extends Component {
  state = {
    buttonText: "Take me to the bulk folder",
  };

  _onClose = () => {
    this.props.onClose();
  };

  _moveToFolder = () => {
    const { urlPathname } = this.props;
    window.open(
      `${window.location.origin}${
        urlPathname.startsWith("/") ? "" : "/"
      }${urlPathname}`,
    );
    // this._onClose();
    // window.location.pathname = this.props.urlPathname;
  };

  render() {
    return (
      <Modal
        open
        onClose={this._onClose}
        closeOnOverlayClick={false}
        center
        styles={{
          modal: {
            maxWidth: "470px",
            minWidth: "450px",
            paddingLeft: "10px",
            paddingRight: "10px",
            borderRadius: "10px",
          },
        }}>
        <div
          className="quotationtopbar-container"
          data-test="quotationtopbar-container">
          <div className="bulkupload-confirm-image">
            <div className="bulkupload-confirm-text">
              <div className="bulkupload-confirm-title">Done!</div>
              <div className="bulkupload-acceptance-filler-subtitle">
                Your request to create documents in bulk with selected data is
                queued. You will get an email once all the documents are
                successfully created.
              </div>
            </div>
            <img
              src={AcceptanceGraphic}
              alt="Revv"
              className="document-acceptance-confirmation-image-datastudio"
            />
          </div>
          <div className="form-group referral-flex-display">
            <div className="referral-popup-link-data-studio">
              <div className="referral-link-share">
                <Button
                  data-test="copy-invite-code"
                  type="four"
                  className="btn btn-primary success-moveto-folder"
                  onClick={this._moveToFolder}>
                  <FontAwesomeIcon
                    icon={["fas", "right-to-bracket"]}
                    className=""
                  />
                  &nbsp; {this.state.buttonText}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default SuccessCreationPopup;
